import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LandingComponent} from "./landing/landing.component";
import {onlyLandingGuard} from "../guards/only-landing.guard";

const routes: Routes = [
  { path: '', component: LandingComponent, canActivate:[onlyLandingGuard] }, // Redirect to the external website
  { path: ':pageId', component: LandingComponent }, // Define the route for the landing component
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
